import { asyncAction } from 'lib/actionCreators'

export const managerProfileView = asyncAction('manager/MANAGER_PROFILE_VIEW')
